import React from 'react';
import PropTypes from 'prop-types';

/**
 * Кнопка для сброса всех фильтров.
 *
 * @param {Object} props - Свойства компонента.
 * @param {boolean} props.showBtnReset - Отображать кнопку или нет.
 * @param {Function} props.onReset - Обработчик клика по кнопке.
 */
const ResetFiltersButton = ({ showBtnReset, onReset }) => {
  return (
    <button
      type="button"
      className={`accordeon__reset-filters ${showBtnReset && 'accordeon__reset-filters_visible'}`}
      onClick={onReset}
    >
      <span className="accordeon__reset-filters_text">Сбросить все фильтры</span>
      <img className="accordeon__reset-filters_icon" src="/image/close.svg" alt="Иконка сброса"></img>
    </button>
  );
};

ResetFiltersButton.propTypes = {
  showBtnReset: PropTypes.bool.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default ResetFiltersButton;
